import React from "react";
import { Link } from "react-router-dom";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { HiArrowUpRight } from "react-icons/hi2";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container-x">
        <div className="footer__top">
          <div className="footer__brand">
            <span className="eyebrow">Get in touch</span>
            <h3>
              Have a project in mind?
              <br />
              <span className="serif-it text-accent">Let's build it.</span>
            </h3>
            <p>
              Available for full-time, contract and freelance work. Based in
              New York, working worldwide.
            </p>
            <Link className="btn" to="/contact">
              Open the contact form
              <span className="arrow"><HiArrowUpRight /></span>
            </Link>
          </div>

          <div className="footer__col">
            <h5>Navigate</h5>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/project">Projects</Link></li>
              <li><Link to="/shopify-portfolio">Shopify</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/resume">Resume</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h5>Services</h5>
            <ul>
              <li><Link to="/services/shopify-development">Shopify Development</Link></li>
              <li><Link to="/services/web-apps">Full-Stack Web Apps</Link></li>
              <li><Link to="/services/api-backend">API & Backend</Link></li>
              <li><Link to="/services/performance-seo">Performance & SEO</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h5>Connect</h5>
            <ul>
              <li><a href="https://github.com/oguzhanozcelik" target="_blank" rel="noreferrer noopener">GitHub</a></li>
              <li><a href="https://www.linkedin.com/in/oguzhanozcelik/" target="_blank" rel="noreferrer noopener">LinkedIn</a></li>
              <li><a href="https://twitter.com/oguzhanozcelikk" target="_blank" rel="noreferrer noopener">Twitter / X</a></li>
              <li><a href="https://www.instagram.com/oguzhanozcelikk" target="_blank" rel="noreferrer noopener">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© {year} Oguzhan Ozcelik. All rights reserved.</span>
          <ul className="footer__social" aria-label="Social links">
            <li>
              <a href="https://github.com/oguzhanozcelik" target="_blank" rel="noreferrer noopener" aria-label="GitHub">
                <AiFillGithub />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/oguzhanozcelik/" target="_blank" rel="noreferrer noopener" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/oguzhanozcelikk" target="_blank" rel="noreferrer noopener" aria-label="Twitter">
                <AiOutlineTwitter />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/oguzhanozcelikk" target="_blank" rel="noreferrer noopener" aria-label="Instagram">
                <AiFillInstagram />
              </a>
            </li>
          </ul>
          <span>New York, US · Working worldwide</span>
        </div>
      </div>
    </footer>
  );
}
